const loader2 = document.getElementById('page-loader');
document.addEventListener('DOMContentLoaded', async (event) => {
  const invalid_url_sharecart = document.getElementById('invalid_url_sharecart');
  const invalidurlsharecart = document.querySelector('.invalid_url_sharecart');
    try {
        // Check if cart needs reloading based on cartToken and sessionStorage
        const cartToken = checkCartTokenInUrl();
        const storedCartToken = sessionStorage.getItem('storedCartToken');
  
        if (cartToken && cartToken !== storedCartToken) {
          sessionStorage.setItem('storedCartToken', cartToken);
          console.log('Page will reload to reflect the updated cart.');
              await fetch('/cart/clear.js', {
                method: 'POST',
              }).then(response => response.json())
                .then(data => {
                  console.log('Cart cleared:', data);
                })
                .catch((error) => {
                  console.error('Error clearing cart:', error);
                });
          const cartContent = await retrieveCart();
          console.log('CART CONTENT IS:', cartContent);
          await refreshCart(); 
          console.log("refreshcart token validate");
        } else {
          console.log('Cart is up to date, no reload needed.');
        }
    } catch (error) {
      console.error('Error retrieving cart:', error);
      if (invalidurlsharecart) {
        invalidurlsharecart.style.display = 'block';
      }
    } finally {
      // Hide loader after processing
      loader2.classList.add('hidden');
      $('#AjaxCartSubtotal').css('display', 'block');

      // Dispatch custom event to signal completion
    document.dispatchEvent(new Event('customCartLoaded'));
    }
});

const checkCartTokenInUrl = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('cart_token');
};

const retrieveCart = async () => {
  const cartToken = checkCartTokenInUrl();  
  const apiUrl = KROWN.settings.shared_cart.get_cart_by_token + cartToken;
    try {
      const response = await fetch(apiUrl, { method: 'POST' });
      const data = await response.json();
      console.log('DATE LOGGED', data);
      await addProductsToCart(data);
      } catch (error) {
      console.error('Error fetching cart data:', error);
  }
};

const addProductsToCart = async (sharedCartData) => {
  // Fetch the current cart content to avoid adding duplicates
      const prodsToAdd = sharedCartData.items.map(item => ({
        id: item.variant_id,
        quantity: item.quantity, // Directly use the quantity from JSON
        selling_plan:item.selling_plan_allocation && item.selling_plan_allocation.selling_plan 
          ? item.selling_plan_allocation.selling_plan.id 
          : null,
        properties: item.properties
      }));

    const cartAttributes = sharedCartData.attributes
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: cartAttributes,
          items: prodsToAdd
        })
      });
      if (!response.ok) {
        throw new Error('Failed to add products to cart');
      }
      sessionStorage.setItem("paymentMethodType", cartAttributes._paymentMethod);
      const data = await response.json();
      console.log('All products added to cart:', data);
    } catch (error) {
      console.error('Error adding products to cart:', error);
    }
};
